<template>
  <div
    class="tab-pane fade in"
    :class="{ active: vx_activeTab === 'road' }"
    role="tabpanel"
  >
    <div class="table-responsive">
      <table class="table table-striped jambo_table bulk_action">
        <thead>
          <tr class="headings fontSize14">
            <th
              v-for="head in HEAD"
              class="column-title word_center"
              width="40px"
            >
              {{ head }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(row, idx) in vx_list">
            <tr
              v-if="vx_list.length"
              :class="{
                even: idx % 2 == 0,
                odd: idx % 2 != 0,
              }"
              class="text_hailing fontSize16"
            >
              <td class="word_center">{{ row.id }}</td>
              <td class="word_center">
                <template v-if="row.callNumber">
                  <div>{{ row.callNumber.split(' ')[0] }}</div>
                  <div>{{ row.callNumber.split(' ')[1] }}</div>
                </template>
              </td>
              <td class="word_left" width="150">{{ row.onLocation }}</td>
              <td class="word_left" width="150">{{ row.offLocation }}</td>
              <td class="word_center">{{ formatDate(row.createdTime) }}</td>
              <td class="word_center">{{ formatDate(row.finishTime) }}</td>
              <td class="word_center">{{ row.actualPrice }}</td>
            </tr>
          </template>
        </tbody>
      </table>
      <!--頁籤-->
      <el-row>
        <el-col :offset="10">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="onPageChange"
            :current-page="vx_roadPaging.currentPage"
            :page-count="vx_roadPaging.totalPages"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { road } from '@/constants/tableHead'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  computed: {
    ...mapState('transaction', {
      vx_activeTab: 'activeTab',
      vx_roadPaging: 'roadPaging',
      vx_list: 'roadList',
    }),
  },
  methods: {
    ...mapMutations('transaction', {
      vx_setRoadPagingCurrentPage: 'setRoadPagingCurrentPage',
    }),
    ...mapActions('transaction', {
      vx_fetchList: 'fetchList',
    }),
    onPageChange(page) {
      this.vx_setRoadPagingCurrentPage(page)
      this.vx_fetchList()
    },
    formatDate(date) {
      if (date) {
        return dayjs(date).add(8, 'hour').format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    },
  },
  created() {
    this.HEAD = road
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/transaction/components/Road.vue